import { Link, usePage } from '@inertiajs/react'
import { cn } from '@/shared/lib/utils'
import { t } from '@/shared/lib/i18n'
import { adminUsersPath, adminLoggersPath } from '@/shared/lib/routes'
import { useCan } from '@/shared/hooks/useCan'
import { Resources, Actions } from '@/shared/rbac'

const UsersLoggersTabs = () => {
  const { url } = usePage()
  const isUsers = url.startsWith(adminUsersPath())
  const isLoggers = url.startsWith(adminLoggersPath())
  const canReadLoggers = useCan(Resources.ADMIN_LOGGER, Actions.READ)

  const tabClass = (active: boolean) =>
    cn(
      'border-b-2 px-4 py-2 text-sm font-medium transition-colors',
      active
        ? 'border-primary text-foreground'
        : 'border-transparent text-muted-foreground hover:text-foreground',
    )

  return (
    <div className="flex border-b mb-6" role="tablist" aria-label={t('nav.administration')}>
      <Link href={adminUsersPath()} className={tabClass(isUsers)}>
        {t('nav.users')}
      </Link>
      {canReadLoggers && (
        <Link href={adminLoggersPath()} className={tabClass(isLoggers)}>
          {t('nav.loggers')}
        </Link>
      )}
    </div>
  )
}

export default UsersLoggersTabs
